import APIKit from "../Allapis/Apikit/apikit";

export const getuserProfile = async (user_id) => {
  const response = await APIKit.get(`users/${user_id}`);
  const data = await response.json();
  return data;
};

export const updateUserspro = async (Data, userpro_id) => {
  const res = await APIKit.put(`users/${userpro_id}`, Data);
  return res.data;
};

export const editUsers = async (userId) => {
  try {
    const url = `/users/${userId}`;
    const result = await APIKit.get(url);
    return result.data;
  } catch (e) {
    return e.response ? e.response : e;
  }
};
export const updateUsers = async (values) => {
  console.log({ values1234567890: values });
  try {
    const url = `/users/updateUserID`;
    const updatedValues = { ...values, type: "Profile" };
    const result = await APIKit.put(url, updatedValues);
    console.log({ UpdateResult: result });
    return result.data;
  } catch (e) {
    return e.response ? e.response : e;
  }
};
